<template>
    <div>
        <section class="content-header" v-if="showContentHeader">
            <div class="row">
                <div class="col-md-7">
                    <slot name="header"></slot>
                </div>
                <div class="col-md-5 text-right">
                    <slot name="buttons"></slot>
                </div>
            </div>
        </section>
        <section class="vuetify-container">
            <slot></slot>
        </section>
        <footer>
            <slot name="footer"></slot>
        </footer>
    </div>
</template>
<script>
  export default {
    props: {
      showContentHeader: {
        type: Boolean,
        default: true
      },
    },
  };
</script>
<style lang="css" scoped>

    .vuetify-container {
        @import '~vuetify/dist/vuetify.min.css';
    }

    label.v-label {
        font-weight: 300 !important;
        margin-bottom: 0;
    }

    .v-snack__content {
        justify-content: left !important;
    }

    .align-items-center {
        align-items: center;
        display: inline-flex;
    }

    .content-header{
        margin:-15px -15px 15px -15px;
    }

</style>
